// import _ from 'lodash';
import 'browser-polyfill';
import React from 'react';
import 'react-dom';
import createReactClass from 'create-react-class';
import * as ReactRouter from 'react-router';

import { createStore } from 'redux';
import { Provider } from 'react-redux';

import reducers from './reducers';

// import './client/QB-native-support';
// import './client/cookieQbid';

import './entries/x5CommentBtnClick';
// import './client/performance';

import './client/error-trace';
import routesContainer from './containers/routes';

// eslint-disable-next-line react/no-deprecated
React.createClass = createReactClass;
const render = require('./externals/react-transmit/render');

const store = createStore(reducers);
const init = () => {
  const reactRoot = window.document.getElementById('react-root');
  render(
    (props) => (
      <Provider store={store}>
        <ReactRouter.Router {...props} />
      </Provider>
    ),
    {
      routes: routesContainer,
      history: ReactRouter.browserHistory,
    },
    reactRoot,
  );
};

const { readyState } = document;
if (readyState === 'complete' || readyState === 'loaded' || readyState === 'interactive') {
  init();
} else {
  window.addEventListener('DOMContentLoaded', init);
}

// trigger scroll event to load lazy images
const event = window.document.createEvent('Events');
event.initEvent('scroll', true, true);
window.dispatchEvent(event);

console.log('v-comt133');
